import React, { Component } from "react";
import { Props } from "./horariosClubesComponentTypes";
import HorariosClubesContainer from "./HorariosClubesContainer";

class HorariosClubesComponent extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return <HorariosClubesContainer {...this.props} />;
  }
}

export default HorariosClubesComponent;
